import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';
import { getDatabase, ref, set, get } from 'firebase/database';
import './style/account.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const auth = getAuth();
  const db = getDatabase();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // Crée un profil par défaut si l'utilisateur n'existe pas encore.
      const userRef = ref(db, `users/${user.uid}`);
      const userSnapshot = await get(userRef);

      if (!userSnapshot.exists()) {
        await set(userRef, {
          name: '',
          email: user.email,
          likedFilms: [],
          dateJoined: new Date().toISOString(),
        });
      }

      navigate('/');
    } catch (err) {
      let customMessage;
      switch (err.code) {
        case 'auth/invalid-email':
          customMessage = 'Votre adresse e-mail semble être mal formée.';
          break;
        case 'auth/user-disabled':
          customMessage = 'Votre compte a été désactivé.';
          break;
        case 'auth/user-not-found':
          customMessage = 'Aucun compte ne correspond à cette adresse e-mail.';
          break;
        case 'auth/wrong-password':
          customMessage = 'Votre mot de passe est incorrect.';
          break;
        default:
          customMessage = "Une erreur s'est produite pendant la connexion.";
      }
      setError(customMessage);
    } finally {
      setLoading(false);
    }
  };

  const requestAccess = () => {
    const subject = encodeURIComponent("Demande d'accès au site");
    const body = encodeURIComponent(`Bonjour,\n\nJe souhaite demander un accès au site.\n\nMerci,\n${email}`);
    const contactEmail = process.env.REACT_APP_CONTACT_EMAIL;
    window.open(`mailto:${contactEmail}?subject=${subject}&body=${body}`);
  };

  return (
    <div className="bb-auth">
      <div className="bb-auth__brand">
        <img
          src={`${process.env.PUBLIC_URL}/logo.png`}
          className="bb-auth__logo"
          alt="Logo Boubou Studio"
          width="52"
          height="52"
        />
        <span className="bb-auth__brandname bb-display">Boubou Studio</span>
      </div>

      <form className="bb-auth__card" onSubmit={handleSubmit}>
        <div>
          <h1 className="bb-auth__title bb-display">Connexion</h1>
          <p className="bb-auth__subtitle">Bienvenue au studio. Connecte-toi pour accéder au catalogue.</p>
        </div>

        <div className="bb-field">
          <label className="bb-field__label" htmlFor="email">Email</label>
          <input
            id="email"
            className="bb-input"
            type="email"
            value={email}
            autoComplete="email"
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <div className="bb-field">
          <label className="bb-field__label" htmlFor="password">Mot de passe</label>
          <input
            id="password"
            className="bb-input"
            type="password"
            value={password}
            autoComplete="current-password"
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>

        {error && <p className="bb-auth__error" role="alert">{error}</p>}

        <button type="submit" className="bb-btn bb-btn--primary bb-btn--block" disabled={loading}>
          {loading ? 'Connexion…' : 'Se connecter'}
        </button>

        <div className="bb-auth__sep" />

        <p className="bb-auth__subtitle bb-auth__subtitle--center">Pas encore de compte&nbsp;?</p>
        <button type="button" className="bb-btn bb-btn--block" onClick={requestAccess}>
          Demander un accès
        </button>
      </form>
    </div>
  );
};

export default Login;
